import React, { useState } from "react";
import { Flex, useDisclosure } from "@chakra-ui/react";
import Navigation from "../components/navigation/Navigation";
import MobileNavigation from "../components/navigation/MobileNavigation";
import useWindowWidth from "../hooks/useWindowWidth";
import TopHeader from "../components/navigation/TopHeader";
import OnboardingModal from "../components/funds/Onboarding/OnboardingModal";
import CurrencyConverterDrawer from "../components/dashboard/CurrencyConverterDrawer";
import TaskDrawer from "../components/tasks/TaskDrawer";
import NewReportModal from "../components/reports/NewReportModal";
import { useAppContext } from "../contexts/AppContext";
import useReportManager from "../hooks/useReportManager";
import FullScreenReportModal from "../components/reports/FullScreenReportModal";

function BackendLayout({ children, setIsAuthenticated }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalType, setModalType] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null); // State for task selection
  const { setTasks, isCollapsed, data: funds } = useAppContext(); // Add funds from AppContext
  const reportManager = useReportManager();

  const NavigationComponent = useWindowWidth() < 960 ? MobileNavigation : Navigation;

  const openModal = (type) => {
    setModalType(type);
    onOpen();
  };

  const openTaskDrawer = (task = null) => {
    setSelectedTask(task);
    setModalType("taskDrawer");
    onOpen();
  };

  const handleSubmit = (updatedTask) => {
    setTasks((prevTasks) => {
      const taskIndex = prevTasks.findIndex((t) => t.id === updatedTask.id);
      if (taskIndex >= 0) {
        const newTasks = [...prevTasks];
        newTasks[taskIndex] = updatedTask;
        return newTasks;
      } else {
        return [...prevTasks, updatedTask];
      }
    });
    onClose();
  };

  const handleNewReportSubmit = (reportData) => {
    reportManager.openFullScreenReportModal(reportData.fund, reportData.reportType);
  };
  

  return (
    <Flex
      direction="row"
      w="100vw"
      sx={{
        th: {
          color: "grey.400",
          fontSize: "10px",
          fontWeight: "500",
          letterSpacing: "-.02em",
          lineHeight: "1",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textTransform: "uppercase",
          whiteSpace: "nowrap",
          borderColor: "grey.200",
        },
        td: {
          borderColor: "grey.200",
        },
        "tbody > tr": { cursor: "pointer" },
        "tbody > tr:hover": { bg: "grey.50" },
        ".hasCheckbox > thead > tr > th:first-of-type": {
          pr: 0,
        },
        "table.hasCheckbox > tbody > tr > td:first-of-type": {
          pr: 0,
        },
      }}
    >
      <NavigationComponent setIsAuthenticated={setIsAuthenticated} />
      <Flex
        as="main"
        direction="column"
        flex={1}
        maxW={{
          lg: isCollapsed ? "calc(100vw - 78px)" : "calc(100vw - 220px)",
          base: "100vw",
        }}
      >
        <TopHeader openModal={openModal} openTaskDrawer={openTaskDrawer} reportManager={reportManager} />
        <Flex direction="column" flex={1} overflowX={"hidden"}>
          <Flex
            direction="column"
            p={{ xl: 16, lg: 12, base: 6 }}
            pb={{ xl: 16, lg: 12, base: 36 }}
            gap={{ xl: 16, base: 8 }}
            w={"100%"}
            maxW={{ xl: "1640px", lg: "1320px" }}
          >
            {React.Children.map(children, (child) =>
                React.cloneElement(child, {
                  onOpen: openModal,
                  openTaskDrawer,
                  reportManager,
                })
              )}
          </Flex>
        </Flex>
      </Flex>

      {/* New Report Modal */}
{reportManager.isNewReportModalOpen && (
  <NewReportModal
    isOpen={reportManager.isNewReportModalOpen}
    onClose={reportManager.closeNewReportModal}
    funds={funds}
    onSubmit={handleNewReportSubmit}
  />
)}

{/* Fullscreen Report Modal */}
{reportManager.isFullScreenReportModalOpen && (
  <FullScreenReportModal
    isOpen={reportManager.isFullScreenReportModalOpen}
    onClose={reportManager.closeFullScreenReportModal}
    reportData={{
      fund: reportManager.selectedFund,
      reportType: reportManager.selectedReportType,
      isNew: !reportManager.selectedFund && !reportManager.selectedReportType,
    }}
  />
)}



      {modalType === "CurrencyConverter" && (
        <CurrencyConverterDrawer isOpen={isOpen} onClose={onClose} />
      )}

      {modalType === "onboardingProcess" && (
        <OnboardingModal
          isOpen={isOpen}
          onClose={() => {
            setModalType(null);
            onClose();
          }}
        />
      )}

      {modalType === "taskDrawer" && (
        <TaskDrawer
          isOpen={isOpen}
          onClose={() => {
            setModalType(null);
            onClose();
          }}
          onSave={handleSubmit}
          task={selectedTask}
        />
      )}
    </Flex>
  );
}

export default BackendLayout;
